import { getApiUrl, PERFORMANCE_API_URL } from '../../util/api/api'
import side from '../../../util/side/side'
import type { JobsStatistics } from '../../../state/reducers/jobs/jobs'

export type JobMetrics = {
  apply: number
  apply_click: number
  apply_click_booster: number
  booster_activated_at: Date | null | undefined
  detail_view: number
  detail_view_booster: number
  search_result: number
  topbaan_result: number
}

export const aggregateReports = (reports: Array<JobMetrics>): JobMetrics => {
  if (!Array.isArray(reports)) {
    return {} as JobMetrics
  }

  return reports.reduce(
    (acc, cur) => ({
      apply: acc.apply + cur.apply || 0,
      apply_click: acc.apply_click + cur.apply_click || 0,
      apply_click_booster: acc.apply_click_booster + cur.apply_click_booster || 0,
      booster_activated_at: acc.booster_activated_at || cur.booster_activated_at,
      detail_view: acc.detail_view + cur.detail_view || 0,
      detail_view_booster: acc.detail_view_booster + cur.detail_view_booster || 0,
      search_result: acc.search_result + cur.search_result || 0,
      topbaan_result: acc.topbaan_result + cur.topbaan_result || 0,
    }),
    {
      apply: 0,
      apply_click: 0,
      apply_click_booster: 0,
      booster_activated_at: undefined,
      detail_view: 0,
      detail_view_booster: 0,
      search_result: 0,
      topbaan_result: 0,
    },
  )
}

const fetchStatistics = async (jobIds: string[]): Promise<JobsStatistics | null> => {
  if (side() === 'server') return {}
  try {
    const queryString = jobIds.map(id => `jobId=${id}`).join('&')

    const fetchResponse = await fetch(
        getApiUrl(`${PERFORMANCE_API_URL}?${queryString}`), {
          headers: {
            'Content-Type': 'application/json',
          },
          mode: 'cors',
          credentials: 'include',
        }
      )
    
    const responseJson = (fetchResponse?.ok) ? await fetchResponse.json() : {}

    const statistics = {}
    Object.keys(responseJson || {}).forEach(id => {
      if (!responseJson[id]) {
        return
      }
      const aggregatedReports = aggregateReports(responseJson[id])
      statistics[id] = {
        jobId: id,
        apply: aggregatedReports.apply,
        applyClick: aggregatedReports.apply_click,
        applyClickBooster: aggregatedReports.apply_click_booster,
        boosterActivatedAt: aggregatedReports.booster_activated_at,
        detailView: aggregatedReports.detail_view,
        detailViewBooster: aggregatedReports.detail_view_booster,
        searchResult: aggregatedReports.search_result,
        topbaanResult: aggregatedReports.topbaan_result,
      }
    })
    return statistics
  } catch (error) {
    throw new Error(`An error has occurred while fetching statistics: ${error.message}`)
  }
}

export default fetchStatistics
